import { render, staticRenderFns } from "./ExportacaoTateti.vue?vue&type=template&id=58c9defe"
import script from "./ExportacaoTateti.vue?vue&type=script&lang=js"
export * from "./ExportacaoTateti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports